module.exports = __webpack_public_path__ + "media/images/layouts/group_tables-48b51a43c19a19977caf056534387d39.png";